import { Flex, Text } from "@chakra-ui/react";
import { useUI } from "providers/UIProvider";


interface IReservationDetailsTotalPrice {
    totalPrice: number
}

const ReservationDetailsTotalPrice: React.FC<IReservationDetailsTotalPrice> = ({ totalPrice }) => {

    const { T } = useUI();

    return (
        <Flex
            padding="16px 23px"
            justifyContent="space-between"
            borderBottom="1px solid #E9F2FD"
            width="100%"
            alignItems="center"
            height="50px"
        >
            <Text fontSize="12px">{T("booking.details.modal.booking.total.price")}</Text>
            <Flex
                alignItems="center"
                justifyContent="center"
                fontSize="18px"
                color="#FFFFFF"
                border="1px solid #046CEC"
                backgroundColor="#046CEC"
                height="32px"
                width="68px"
                borderRadius="16px"
                fontWeight="500"
            >
                {totalPrice}₾
            </Flex>
        </Flex>
    )
};

export default ReservationDetailsTotalPrice;